import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseTableComponent } from '../base-table/base-table.component';
import { ProductDiscount } from 'src/app/entities/product-discount';
import { ProductDiscountService } from 'src/app/services/product-discount.service';
import { AlertService } from 'src/app/services/alert.service';
import { fuseAnimations } from '@mobileia/layout-fuse';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { MIATableModel } from '@mobileia/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-product-discount',
  templateUrl: './product-discount.component.html',
  styleUrls: ['./product-discount.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ProductDiscountComponent extends BaseTableComponent<ProductDiscount> implements OnInit {

  displayedColumns = ['id', 'product_id', 'external_code', 'title', 'percent', 'from', 'to', 'status', 'actions'];
  configColumns = [
    {
      key: 'id',
      field_key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600'
    },
    {
      key: 'product_id',
      field_key: 'product_id',
      type: 'integer',
      title: 'Producto_ID',
      classes: ''
    },
    {
      key: 'external_code',
      field_key: 'external_code',
      type: 'string',
      title: 'Código',
      classes: ''
    },
    {
      key: 'title',
      field_key: 'title',
      type: 'string',
      title: 'Titulo',
      classes: ''
    },
    {
      key: 'percent',
      field_key: 'percent',
      type: 'integer',
      title: 'Porcentaje Dscto.',
      classes: ''
    },    
    {
      key: 'from',
      field_key: 'from',
      type: 'string',
      title: 'Desde',
      classes: ''
    },
    {
      key: 'to',
      field_key: 'to',
      type: 'string',
      title: 'Hasta',
      classes: ''
    },
    {
      key: 'status',
      field_key: 'status',
      type: 'option',
      title: 'Estado',
      classes: '',
      options: {
        '0': {
          title: 'Inactivo'
        },
        '1': {
          title: 'Activo'
        },
      }
    },    
  ];

  filterStatus = -1;
  filterDate;

  constructor(
    protected discountService: ProductDiscountService,
    protected alertService: AlertService
  ) {
    super(alertService);
    this.service = discountService;
  }

  ngOnInit(): void {
    this.loadItems();
  }

  onSearch() {
    if (this.filterSearch != '') {
      this.tableModel.addwhereLike('product.title', this.filterSearch);    
    } else if (this.filterSearchCodigo != '') {
      this.tableModel.addwhereLike('product.external_code', this.filterSearchCodigo);
    } else if(this.filterSearch == "" && this.filterSearchCodigo == ""){
      this.tableModel.resetWhere();
    }
    this.loadItems();
  }
}